const $ = jQuery.noConflict();
function checkAnchorsOnLoad() {
	window.setTimeout(() => {
		const link = window.location.href;
		const headerElement = $('.main-header');
		const wpadminbar = $('#wpadminbar');
		let id;
		let stickyOffHeight = 8;

		if (headerElement) {
			stickyOffHeight += headerElement.outerHeight();
		}

		if (wpadminbar) {
			stickyOffHeight += 32;
		}

		if (link.indexOf('#') > -1) {
			id = link.substring(link.lastIndexOf('#') + 1);
		}
		if (id) {
			const distance = document.querySelector(`#${id}`).getBoundingClientRect().top + window.pageYOffset;
			$('html, body').animate({
				scrollTop: distance - stickyOffHeight
			}, 600);

		}
	}, 5);
}
export default checkAnchorsOnLoad;
